import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IceButton from "../../components/Button";

export default function DialogInfo(props: any) {
    let {open, setOpen, mapInfo} = props

    return (

        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Mapping Info</DialogTitle>

            <DialogContent>

                <DialogContentText style={{fontSize: '0.85rem'}}>
                    {mapInfo.mapID && <><span>Mapping ID: {mapInfo.mapID}</span><br/></>}
                    <span>Last update: {mapInfo.mapDate?.replace('T', ' at ').replace('Z', '')} (+3 EET)</span><br/>
                    <span>Last user action: {mapInfo.mapUser}</span><br/>
                    <span>Mapping status: {mapInfo.mapStatus ? mapInfo.mapStatus : 'not mapped'}</span><br/>
                </DialogContentText>

            </DialogContent>

            <DialogActions>
                {/*<Button onClick={handleClose}>Close</Button>*/}
                <IceButton type="primary" text="Close" onclick={() => setOpen(false)} />
            </DialogActions>

        </Dialog>
    );
}